import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Stack,
    Box,
    IconButton,
    Chip,
} from '@mui/joy';
import { ArrowForward } from '@mui/icons-material';

/**
 * Shared module / tool tile used on the dashboard and Tools page.
 * Icon, title, short description, optional badge, arrow affordance.
 */
const BranchCard = ({
    title,
    description,
    icon: Icon,
    color = 'primary',
    onClick,
    badge,
    disabled = false,
}) => (
    <Card
        variant="outlined"
        sx={{
            width: '100%',
            height: '200px',
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.6 : 1,
            transition: 'all 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            '&:hover': disabled
                ? {}
                : {
                      transform: 'translateY(-2px)',
                      boxShadow: 'md',
                  },
        }}
        onClick={disabled ? undefined : onClick}
    >
        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Stack spacing={2} sx={{ height: '100%' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                    <Box
                        sx={{
                            p: 1.5,
                            borderRadius: 'md',
                            backgroundColor: `${color}.softBg`,
                            color: `${color}.500`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Icon sx={{ fontSize: 28 }} />
                    </Box>
                    {badge && (
                        <Chip size="sm" color={color} variant="soft">
                            {badge}
                        </Chip>
                    )}
                </Stack>

                <Box sx={{ flex: 1, minHeight: 0 }}>
                    <Typography level="title-lg" sx={{ mb: 1, lineHeight: 1.2 }}>
                        {title}
                    </Typography>
                    <Typography
                        level="body-sm"
                        textColor="neutral.600"
                        sx={{
                            lineHeight: 1.4,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {description}
                    </Typography>
                </Box>

                <Stack direction="row" justifyContent="flex-end" sx={{ mt: 'auto' }}>
                    <IconButton size="sm" variant="soft" color={color} disabled={disabled}>
                        <ArrowForward />
                    </IconButton>
                </Stack>
            </Stack>
        </CardContent>
    </Card>
);

export default BranchCard;
